/* ICI WA-DIRECT v1 (2026-10-21)
   Apunta los enlaces de WhatsApp (wa.me) a redirecciones del mismo dominio para que Shopify
   no muestre el aviso de salida "Are you sure you want to leave". El texto prellenado (?text=) se conserva.
   Redirecciones de URL (Tienda online > Navegacion): /whatsapp -> wa.me/50368353128 ; /wa-50322641000 -> wa.me/50322641000
   Rollback: quitar el bloque ICI WA-DIRECT de layout/theme.liquid (respaldo: assets/ici-backup-wadirect-layout-theme-liquid-20261021.txt). */
(function () {
  'use strict';
  var MAP = { '50368353128': '/whatsapp', '50322641000': '/wa-50322641000' };
  var RE_WA = /^(?:https?:)?[/][/]wa[.]me[/][+]?([0-9]{8,13})[/]?(?:[?]([^#]*))?/i;
  var RE_API = /^https?:[/][/](?:api|web)[.]whatsapp[.]com[/]send[/]?[?]([^#]*)/i;

  function destino(href) {
    var m = RE_WA.exec(href), num, qs = '';
    if (m) { num = m[1]; qs = m[2] || ''; }
    else {
      m = RE_API.exec(href);
      if (!m) { return null; }
      var p = new URLSearchParams(m[1]);
      num = (p.get('phone') || '').replace(/[^0-9]/g, '');
      if (p.get('text')) { qs = 'text=' + encodeURIComponent(p.get('text')); }
    }
    return MAP[num] ? MAP[num] + (qs ? '?' + qs : '') : null;
  }

  function fix(a) {
    if (!a || a.nodeName !== 'A') { return; }
    var href = a.getAttribute('href');
    if (!href) { return; }
    var d = destino(href);
    if (d) { a.setAttribute('data-ici-wa', href.split('?')[0]); a.setAttribute('href', d); }
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) { return; }
    if (root.nodeName === 'A') { fix(root); }
    var l = root.querySelectorAll('a[href*="wa.me"],a[href*="whatsapp.com"]');
    for (var i = 0; i < l.length; i++) { fix(l[i]); }
  }

  scan(document);

  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i];
      if (m.type === 'attributes') { fix(m.target); }
      else {
        for (var j = 0; j < m.addedNodes.length; j++) {
          if (m.addedNodes[j].nodeType === 1) { scan(m.addedNodes[j]); }
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

  function antes(e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (a) { fix(a); }
  }
  ['pointerdown', 'touchstart', 'focusin', 'mouseover'].forEach(function (n) {
    document.addEventListener(n, antes, { capture: true, passive: true });
  });

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-ici-wa]') : null;
    if (!a) { return; }
    try { if (window.clarity) { window.clarity('event', 'whatsapp_click'); } } catch (x) {}
    try { if (window.gtag) { window.gtag('event', 'whatsapp_click', { link_url: a.getAttribute('data-ici-wa') }); } } catch (x) {}
  }, true);
})();
